const getters = {
  isAuth: () => !!localStorage.getItem('access_token'),
  unreadNotifications: (state) => state.unreadNotifications,
}

export default getters
